// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__awmr-","calendarButtons":"ClockData_calendarButtons__1DMG9"};